<template>
  <el-table-column
    prop="status"
    sortable="custom"
    label="Státusz"
    show-overflow-tooltip
    min-width="100"
  >
    <template slot-scope="scope">
      <el-tag v-if="scope.row.status === 'recorded'" size="small" type="info">Rögzítve</el-tag>
      <el-tag v-if="scope.row.status === 'cancelled'" size="small" type="danger">Lemondva</el-tag>
      <el-tag v-if="scope.row.status === 'lent'" size="small" type="primary">Kihelyezve</el-tag>
      <el-tag v-if="scope.row.status === 'done'" size="small" type="success">Teljesítve</el-tag>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'status',
  };
</script>
